const urlRegex = /(https?:\/\/|www\.)(?:[^\s.]+\.)+[/?#a-zA-Z0-9\-._~!$&'()*+,;=:@%]+/gi;
const emailRegex = /\S+@(?:[^\s.]+\.)+[^\s.]+/g;

const careerHubMarkdownToHtml = (text: string | null | undefined): string => {
    if (!text) {
        return '';
    }

    const lines = htmlEncode(text).split('\n');
    let result = '';
    let inList = false;

    for (let i = 0; i < lines.length; i++) {
        const line = lines[i]
            .replace(/\r$/, '')
            .trim()
            .replace(urlRegex, urlMatchEvaluator)
            .replace(emailRegex, emailMatchEvaluator);

        if ('*••●◦◉○◌◍◎◯▪▫◼■◻□◽◾·‧>▶▷▸▹►▻◆◇◈◊–-'.indexOf(line[0]) != -1) {
            if (!inList) {
                result += '<ul>';
                inList = true;
            }
            result += `<li>${line.substring(1).trimStart()}</li>`;
            continue;
        }

        if (inList) {
            result += '</ul>';
            inList = false;
        }

        if (line.length == 0) {
            result += '<p></p>';
            continue;
        }

        result += `<p>${line}</p>`;
    }

    if (inList) {
        result += '</ul>';
    }

    return result;
};

const urlMatchEvaluator = (match: string): string => {
    const protocol = match.toLowerCase().startsWith('www.') ? 'http://' : '';
    const encoded = htmlEncode(match);
    return `<a rel="noopener noreferrer" target="_blank" href="${protocol}${encoded}">${truncate(
        match,
        50
    )}</a>`;
};

const emailMatchEvaluator = (match: string): string => {
    const encoded = htmlEncode(match);
    return `<a rel="noopener noreferrer" target="_blank" href="mailto:${encoded}">${truncate(
        match,
        50
    )}</a>`;
};

const truncate = (
    value: string | null | undefined,
    maxLength: number
): string | null | undefined => {
    return value && value.length > maxLength ? value.substring(0, maxLength) : value;
};

const htmlEncode = (text: string): string => {
    return text
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
};

export const centralHtmlhelper = {
    fromMarkdown: careerHubMarkdownToHtml,
};
